import { sendAnalytics, SendAnalyticsProps } from './SimpleTriggerEvent';

export interface PageVisualizationEventProps extends SendAnalyticsProps {
  analytics?: PageVisualizationEventProps;
}

export const pageVisualizationEvent = (props: PageVisualizationEventProps) => {
  const analyticsData = props?.analytics || props;
  const { simpleUiEvent, override, additionalInformation } = analyticsData;

  return sendAnalytics({
    simpleUiEvent: simpleUiEvent,
    override: override,
    additionalInformation: additionalInformation,
  });
};
